import axios from 'axios'
import { APP_VERSION } from './constants'
let conf = {}

let isInitialized = false
export const fetchEnv = (force=false) => {
    return new Promise((resolve, reject) => {
        if (!isInitialized || force) {
            axios.get('/env.json?' + APP_VERSION).then((env)=>{
                conf = env.data
                isInitialized = true
                resolve()
            }).catch(reject)
        } else if (isInitialized) {
            resolve()
        } else {
            reject()
        }
    })

}


export const config = (name) => {
    return conf[name]
}